import StateType, { BillingType } from './state.type';

export default {
  toggleLoading(state: StateType, isLoading: boolean): void {
    state.loading = isLoading;
  },
  setInvoices(state: StateType, billings: BillingType[]): void {
    state.billings = billings;
  },
  setTotal(state: StateType, total: number): void {
    state.total = total;
  },
};
